import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import AppBadge from './app-badge'

const STATUS_CONFIG = {
  pending: { variant: 'secondary', label: 'Pending' },
  uploaded: { variant: 'info', label: 'Uploaded' },
  extracting: { variant: 'warning', label: 'Extracting...' },
  extracted: { variant: 'warning', label: 'Review Rules' },
  completed: null,
  failed: { variant: 'danger', label: 'Failed' }
}

const PolicyStatusBadge = ({ status }) => {
  if (status === 'completed') {
    return <small><FontAwesomeIcon icon={faCheck} className="text-success me-1" />Completed</small>
  }

  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending

  return (
    <AppBadge variant={config.variant} style={{ fontSize: '0.7rem' }}>{config.label}</AppBadge>
  )
}

export default PolicyStatusBadge
